<template>
  <div class="container">
    <span class = "mesageBlock">
        {{params.text}}
    </span>
  </div>
</template>

<script>
import {useStore} from 'vuex'
import { onMounted } from 'vue'
import { ABtn, useAModal, AAvatar } from '../../ui'
import {AUTH_STATES} from "../../../store/modules/auth";
export default {
  name: "SystemFormAuth",
  props:['params'],
  setup: (props, ctx) => {
    const $store = useStore();
    const modal = useAModal();
    onMounted(() => {
      modal.show('authPage-modal');
      $store.commit('auth/setAuthState', AUTH_STATES.login);
    });
  }
}
</script>

<style scoped>
  .mesageBlock {
    text-align: center; display: block; padding: 100px 0px; font-size: 25px;
  }
</style>